// extracted by mini-css-extract-plugin
module.exports = {"root":"UfoSvg-module--root--3mbbL","hide":"UfoSvg-module--hide--3nBFi"};